import React, { useState, useEffect } from 'react';
import { IntlProvider } from 'react-intl';
import { ApolloProvider } from '@apollo/client';
import { FeatureExperimentProvider } from '@blocs.features-experiments';
import { MaintenanceGuard } from '@blocs.maintenance';
import { InternationalizationProvider } from '@blocs.i18n';
import Routes from 'src/routes';
import Page from 'components/core/Page';
import { WindowWidthContext } from '@minecraft.utils';
import initApollo from '../lib/init-apollo';
import messages from '../lang/en.json';

const App = () => {
  const [apolloClient, setApolloClient] = useState(undefined);

  useEffect(() => {
    async function initClient() {
      return setApolloClient(await initApollo());
    }
    initClient()?.catch((e) => console.error('init apollo error', { error: e }));
  }, []);

  if (!apolloClient) {
    return null;
  }

  return (
    <InternationalizationProvider>
      <FeatureExperimentProvider>
        <ApolloProvider client={apolloClient}>
          <IntlProvider locale="en" messages={messages}>
            <Page>
              <MaintenanceGuard routes={Routes} />
            </Page>
          </IntlProvider>
        </ApolloProvider>
      </FeatureExperimentProvider>
    </InternationalizationProvider>
  );
};

export default WindowWidthContext.withWidthDataProvider(React.memo(App));
